import { I } from "../Icons.jsx";
import Btn from "../ui/Btn.jsx";

export default function ExportView({ activities, people, eventName, filterActivityId, onClose }) {
  const getName = (pid) => people.find(p => p.id === pid)?.Name || "Unknown";
  const shown = filterActivityId ? activities.filter(a => a.id === filterActivityId) : activities;
  const meta = filterActivityId
    ? `${shown[0]?.name || "Activity"} · ${new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}`
    : `${new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })} · ${people.length} guests · ${activities.length} moments`;

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 2000,
      background: "#fff", color: "#1a1a1a",
      fontFamily: "var(--ui)", overflow: "auto",
    }}>
      <div
        className="no-print"
        style={{
          position: "sticky", top: 0, zIndex: 10,
          background: "#fff", borderBottom: "1px solid #eee",
          padding: "14px 48px", display: "flex", alignItems: "center", gap: 12,
        }}
      >
        <Btn variant="ghost" size="sm" icon={I.arrowLeft} onClick={onClose}>Back to editor</Btn>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: "#999" }}>Ctrl/⌘P to save as PDF</span>
        <Btn variant="primary" size="sm" icon={I.printer} onClick={() => window.print()}>Print</Btn>
      </div>

      <div style={{ maxWidth: 900, margin: "0 auto", padding: "56px 56px 80px" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div style={{
            fontSize: 11, letterSpacing: 3, textTransform: "uppercase",
            color: "#999", marginBottom: 16,
          }}>
            Placement · Seating programme
          </div>
          <div style={{
            fontFamily: "var(--display)",
            fontSize: 42, fontWeight: 400,
            letterSpacing: -0.4, lineHeight: 1.05,
          }}>
            {eventName}
          </div>
          <div style={{ marginTop: 14, fontSize: 13, color: "#555" }}>
            {meta}
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
            <svg width="60" height="10" viewBox="0 0 60 10" fill="none" stroke="#999" strokeWidth="0.8">
              <path d="M2 5h20M38 5h20M28 1v8M24 5h12" strokeLinecap="round" />
            </svg>
          </div>
        </div>

        {shown.map((a, ai) => {
          const assignedIds = new Set();
          a.groups.forEach(gr => gr.people.forEach(pid => assignedIds.add(pid)));
          const absent = people.filter(p => !assignedIds.has(p.id));
          return (
            <div key={a.id} style={{ marginBottom: 48, pageBreakInside: "avoid" }}>
              <div style={{
                borderBottom: "1px solid #ddd",
                paddingBottom: 10, marginBottom: 20,
                display: "flex", alignItems: "baseline", gap: 14,
              }}>
                <div style={{
                  fontFamily: "var(--display)",
                  fontStyle: "italic",
                  fontSize: 15, color: "#999",
                  fontVariantNumeric: "tabular-nums",
                }}>
                  {String(ai + 1).padStart(2, "0")}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontFamily: "var(--display)", fontSize: 24, fontWeight: 400, letterSpacing: -0.2,
                  }}>{a.name}</div>
                  <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                    {a.groups.length} groups · {assignedIds.size} seated
                  </div>
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                {a.groups.map(gr => (
                  <div key={gr.id} style={{ border: "1px solid #e5e5e5", borderRadius: 6, overflow: "hidden" }}>
                    <div style={{
                      padding: "7px 12px",
                      borderBottom: "1px solid #eee",
                      background: "#fafafa",
                      display: "flex", justifyContent: "space-between",
                    }}>
                      <strong style={{ fontSize: 12.5 }}>{gr.name}</strong>
                      <span style={{ fontSize: 11, color: "#999" }}>{gr.people.length}</span>
                    </div>
                    <div style={{ padding: "8px 12px", fontSize: 12.5, lineHeight: 1.75 }}>
                      {gr.people.length === 0 && <em style={{ color: "#ccc" }}>Empty</em>}
                      {gr.people.map((pid) => {
                        const isHost = gr.host === pid;
                        return (
                          <div key={pid} style={{ color: "#333" }}>
                            {isHost && <span style={{ color: "#999", marginRight: 4 }}>★</span>}
                            <span style={{ fontWeight: isHost ? 600 : 400 }}>{getName(pid)}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>

              {absent.length > 0 && absent.length < people.length && (
                <div style={{ marginTop: 10, fontSize: 11, color: "#999", lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 700, color: "#bbb", textTransform: "uppercase", fontSize: 10, letterSpacing: 0.5 }}>
                    Absent ({absent.length}):{" "}
                  </span>
                  {absent.map(p => p.Name).join(", ")}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
